import React from 'react';
import { Route } from 'react-router';
import { useMount } from 'react-use';
import { useDispatch } from 'react-redux';

import { Loader } from '@crm-framework/loader';
import { useRegistry } from '@crm-framework/registry';

import { BaseLayout, Page } from '@crm-package/layouts';
import { Unavailable } from '@crm-package/app';

import { checkTokenRequestAction } from '../actions';
import { TOOLS_REGISTERS } from '../consts';

import { TokenAuth } from './TokenAuth';
import { WithdrawalLayout } from './WithdrawalLayout';

export const ToolsLayout: React.FC<{ name: string }> = ({ name, children }) => {
  const dispatch = useDispatch();
  const token = useRegistry<string | null>(TOOLS_REGISTERS.token, null);
  const isReady = useRegistry<boolean>(TOOLS_REGISTERS.isReady, false);
  const isUnavailable = useRegistry<boolean>(
    TOOLS_REGISTERS.isUnavailable,
    false
  );

  useMount(() => dispatch(checkTokenRequestAction()));

  if (isUnavailable) return <Unavailable />;

  return (
    <Page>
      <BaseLayout>
        <Route
          path="/"
          render={() => {
            if (!isReady) return <Loader fixed />;

            if (token === null) return <TokenAuth />;

            return <WithdrawalLayout name={name}>{children}</WithdrawalLayout>;
          }}
        />
      </BaseLayout>
    </Page>
  );
};
